import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PERSONAL_GLOBAL_REQUEST } from '@neworg-net/amsuite-core/auth';
import { ConfigService } from '@neworg-net/amsuite-core/config';
import { Observable, map, timeout } from 'rxjs';
import { requireHostUrl } from '../../shared/required-host-url';
import { normalizeNotifierDto } from './notification-normalizers';
import { NotifierInboxPage, NotifierInboxPageDto } from './notification.model';

/** Inbox globale dell'utente reale: il contesto HTTP mantiene Bearer e rinnovo sessione. */
@Injectable({ providedIn: 'root' })
export class NotifierInboxService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);

  getPage(page = 1, pageSize = 30): Observable<NotifierInboxPage> {
    return this.http.get<NotifierInboxPageDto>(this.baseUrl(), {
      context: this.personalContext(),
      params: new HttpParams().set('page', page).set('pageSize', pageSize),
    }).pipe(timeout(30_000), map(result => ({ ...result, items: result.items.map(normalizeNotifierDto) })));
  }

  markRead(id: number): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl()}/${id}/read`, null, { context: this.personalContext() }).pipe(timeout(30_000));
  }

  markAllRead(): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl()}/read-all`, null, { context: this.personalContext() }).pipe(timeout(30_000));
  }

  remove(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl()}/${id}`, { context: this.personalContext() }).pipe(timeout(30_000));
  }

  clearThrough(throughId: number): Observable<void> {
    return this.http.delete<void>(this.baseUrl(), {
      context: this.personalContext(), params: new HttpParams().set('throughId', throughId),
    }).pipe(timeout(30_000));
  }

  private baseUrl(): string {
    return `${requireHostUrl(this.config, 'notifier').replace(/\/$/u, '')}/notifier/v1/me/notifications`;
  }

  private personalContext(): HttpContext {
    return new HttpContext().set(PERSONAL_GLOBAL_REQUEST, true);
  }
}
